/**
 * The Client Node PWA's cloud distribution origin — the static site an installed-from-cloud
 * PWA is served from at first launch (e.g. `client-node.economy1.cloud`), as opposed to a
 * `system/pwa/dist` build served directly by a running node (dev, or an on-node install).
 *
 * Mirrors the Rust constant of the same value, `DEFAULT_CLIENT_NODE_ORIGIN` in
 * `core/adapters-network/src/http/server/runtime.rs` (introduced by ticket N1's CORS/PNA
 * work) — kept in sync by hand; update both together if this value ever changes.
 *
 * This origin is NEVER itself a home node — it is a static site with no node behind it.
 * `resolveInitialHomeNode` (`system/pwa/src/kernel-runtime.ts`) uses this constant to
 * recognize "installed-from-cloud, no LAN candidate discovered yet" and refuses to seed it
 * as a dialable bootstrap candidate. Before this constant's introduction (lan-direct-pairing
 * plan, C3), the distribution origin was unconditionally seeded as the `wan-direct`
 * home-node candidate on every boot, so pairing dialed the static site and got a 404.
 */
export const DEFAULT_CLIENT_NODE_ORIGIN = "https://client-node.economy1.cloud";
//# sourceMappingURL=client-node-origin.js.map